export default function Cta() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 pb-12 md:px-6 md:pb-16">
        <div className="relative overflow-hidden rounded-xl bg-foreground-950 px-6 py-10 text-center md:px-12 md:py-12">
          <div className="pointer-events-none absolute -right-8 -top-8 h-44 w-44 rounded-full bg-accent-500/20 blur-2xl" aria-hidden="true" />
          <div className="pointer-events-none absolute -bottom-10 -left-6 h-40 w-40 rounded-full bg-primary-600/25 blur-2xl" aria-hidden="true" />
          <div className="relative mx-auto max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 text-[12px] font-medium text-background-100 ring-1 ring-inset ring-background-50/20">
              <i className="ri-notification-3-line" aria-hidden="true" /> 九色黑料持续流出中
            </span>
            <h2 className="mt-4 font-display text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              想在原图新批次出现时第一时间看到？
            </h2>
            <p className="mx-auto mt-3 max-w-xl text-[14px] leading-7 text-background-100/80">
              收藏本页即可随时回来翻九色黑料图片、视频与截图。新批次与画质修复版会集中在头版与时间线页展示，一眼就能看到最新进度。
            </p>
            <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href="#gallery"
                className="whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-500"
              >
                <i className="ri-bookmark-line mr-1.5" aria-hidden="true" /> 开始翻最新原图
              </a>
              <a
                href="#headline"
                className="whitespace-nowrap rounded-md bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 ring-1 ring-inset ring-background-50/25 transition hover:bg-background-50/20"
              >
                回到头版速览
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}